<section class="garage-header">
  <!-- Background Image -->
  <img src="../../../assets/img/photos/bg3.jpg" class="garage-bg" alt="Garage Background">

  <!-- Overlay Content -->
  <div class="garage-overlay">
    <!-- Logo on top-left -->
    <a href="./index.html" class="top-left-logo">
      <img class="logo-dark" id="GARAGE_LOGO" src="" alt="Garage Logo" style="display: none;"/>
    </a>

    <!-- Garage Name Centered -->
    <div class="head_container text-center">
      <h1 class="display-1 mb-3 text-white">
        {{ garageData?.name }}
      </h1>
    </div>
  </div>
</section>


<section class="wrapper bg-light angled upper-end" *ngIf="garageData">
  <div class="container">
    <div class="row mb-14 mb-md-16">
      <div class="col-xl-10 mx-auto mt-n16">
        <div class="card">
          <div class="row gx-0">
            
            <!-- Map -->
            <div class="col-lg-6 align-self-stretch">
              <div class="map map-full rounded-top rounded-lg-start">
                <div class="map map-full rounded-top rounded-lg-start" style="height: 400px;">
                  
                  <google-map
                    height="400px"
                    width="100%"
                    [center]="center"
                    [zoom]="14">

                    <map-marker
                      #markerElem="mapMarker"
                      [position]="marker.position"
                      [title]="marker.title"
                      [options]="marker.options"
                      (mapClick)="openInfo(markerElem)">
                      
                      <map-info-window>
                        <div>
                          <div style="display:flex; justify-content: space-between; align-items: center;">
                            <h2 style="margin:0;">{{ marker.title }}</h2>
                            <a [href]="directionsLink" target="_blank">
                              <img src="./assets/img/direction_images-removebg-preview.png"
                                  style="width:30px;height:30px; margin-left:10px;">
                            </a>
                          </div>

                          <p>{{ marker.address }}</p>

                          <div style="display:flex; align-items:center;">
                            <strong style="margin-right:5px;">{{ marker.googleRatings }}</strong>
                            <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                              <mat-icon *ngIf="star === 'full'" style="color: gold; margin-right: 2px;">star</mat-icon>
                              <mat-icon *ngIf="star === 'half'" style="color: gold; margin-right: 2px;">star_half</mat-icon>
                            </ng-container>
                            <span style="margin-left: 5px; color:blue;">
                              {{ marker.googleReviewNumbers }} reviews
                            </span>
                          </div>

                          <a [href]="largerMapLink" target="_blank" style="color:blue;">View larger map</a>
                        </div>
                      </map-info-window>
                    </map-marker>
                  </google-map>

                </div>
              </div>
            </div>

            <!-- Details -->
            <div class="col-lg-6">
              <div class="p-10 p-md-11 p-lg-14">
                
                <!-- Address -->
                <div class="d-flex flex-row mb-3">
                  <div>
                    <div class="icon text-primary fs-28 me-4 mt-n1"> 
                      <i class="uil uil-location-pin-alt" style="color:dodgerblue;"></i>
                    </div>
                  </div>
                  <div>
                    <h5 class="mb-1">Address</h5>
                    <address>{{ garageData.address }}</address>
                  </div>
                </div>

                <!-- Ratings -->
                <div class="d-flex flex-row mb-3">
                  <div>
                    <img src="./assets/img/googleicon.png" alt="Google" style="width:28px; height:28px; margin-right:16px;">
                  </div>
                  <div>
                    <h5 class="mb-1">Ratings / Reviews</h5>
                    <div class="div_ratings">
                      <span>{{ garageData.googleRatings }}</span>
                      <div class="div_new_rating">
                        <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                          <mat-icon *ngIf="star === 'full'">star</mat-icon>
                          <mat-icon *ngIf="star === 'half'">star_half</mat-icon>
                        </ng-container>
                      </div>
                      
                    </div>
                    <p>from {{ garageData.googleReviewNumbers }} Google reviews</p>
                  </div>
                </div>

                <!-- Button -->
                <!-- <div class="button_div">
                  <button data-bs-target="#requestCallBackModal"  class="requestBtn" >
                    Request a Call Back
                  </button>
                </div> -->
                <div class="button_div">
                  <button class="requestBtn" (click)="openRequestModal()">
                    Request a Call Back
                  </button>
                </div>


                <!-- ==========requesta-a-call-bac-pop-up======= -->
                 <div class="modal fade" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 35%; top: 60px;">
                        <div class="modal-content" style="border-radius: 16px;">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF);     border-radius: 10px;">
                            <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                            <div class="call-icon-and-text">
                                <img src="./assets/img/call-image.png">
                                <div> Request a Call Back </div>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            
                            </h3>
                            
                        </div>

                        <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 0 !important; font-weight: 400;">Leave your details and (optionally) pick a coupon.</p>

                        <!-- Form -->
                        <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" style="padding: 10px 20px;">
                        <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                        <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                        <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                        <!-- Coupons Section -->
                        <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                            <div *ngFor="let c of coupons" 
                                class="coupon-card-option"
                                [class.active]="selectedCoupon?.couponId === c.couponId"
                                (click)="applyCoupon(c)">
                            <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                            <p class="small m-0 text-muted">{{ c.description }}</p>
                            </div>
                        </div>

                        <!-- <button type="submit" class="submit-btn btn-primary w-100 p-3 fw-bold">
                            Submit Details
                        </button> -->
                         <button type="submit" class="btn btn-primary w-100" style= "background:#144579;">Submit Details</button>
                        
                        </form>
                        </div>
                    </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Coupon Section -->
<div class="coupon-section" *ngIf="coupons && coupons.length > 0">
  <h2>💰 Exclusive Offers Just for You</h2>
  <div class="coupon-row">
    <div *ngFor="let coupon of coupons" class="coupon-card">
      <div class="coupon-title">{{ decodeEntities(coupon.title) }}</div>
      <h3 style="color:#144579">{{ coupon.discount }}% OFF</h3>
      <div class="coupon-subtitle">{{ decodeEntities(coupon.subTitle) }}</div>
      <div class="coupon-code">{{ coupon.couponCode }}</div>
      <button class="redeem-btn" (click)="openModal(coupon)">Redeem Now</button>
    </div>
  </div>
</div>

<!-- Modal -->
<!-- Coupon Modal -->
<div class="modal-coupon" *ngIf="selectedCoupon">
  <div class="modal-content-coupon">

    <!-- Hot Deal Tag -->
    <span class="hot-deal-tag">{{ decodeEntities(selectedCoupon.tagDeal || '🔥 HOT DEAL') }}</span>

    <!-- Close Button -->
    <div class="modal-header-container">
      <div class="modal-header">🎉 Redeem Your Offer</div>
      <span class="close-btn" (click)="closeModal()">&times;</span>
      
    </div>
    <div class="underline"></div>

    <!-- Content -->
    <div class="pop-up-parent-div">
      <div class="modal-subtitle">{{ decodeEntities(selectedCoupon.subTitle) }}</div>
      <div class="valid-date-coupon-code">{{ selectedCoupon.couponCode }}</div>
      <div class="valid-date">Valid till: {{ selectedCoupon.validTill | date:'dd-MMM-yyyy' }}</div>
      <div class="description">{{ decodeEntities(selectedCoupon.description) }}</div>
    </div>

    <!-- Form Inputs -->
    <form [formGroup]="couponForm" (ngSubmit)="applyCouponForm()">
      <input type="text" formControlName="couponName" placeholder="Name*" required class="form-control mb-2 p-2">
        <input type="text" formControlName="couponMobile" placeholder="Mobile Number*" maxlength="10" required class="form-control mb-2 p-2">
        <textarea type="text" formControlName="couponIssue" placeholder="Describe Your Issue (Optional)" class="form-control mb-2 p-2"></textarea>
        <!-- <input type="text" name="couponName" placeholder="Full Name *" required>
        <input type="tel" name="couponMobile" placeholder="Mobile Number *" maxlength="10" required>
        <textarea name="couponIssue" placeholder="Describe Your Issue (Optional)"></textarea> -->
            <button type="button" class="submit-btn btn btn-primary w-100" (click)="applyCouponForm()">
          🚀 Confirm & Apply Coupon
        </button>
      <div class="modal-footer-features">
        <div class="feature-item">
          <span>🔒</span><span>Secure Booking</span>
        </div>
        <div class="feature-item">
          <span>💯</span><span>Money Back Guarantee</span>
        </div>
        <div class="feature-item">
          <span>⚡</span><span>Instant Confirmation</span>
        </div>
      </div>
    </form>

  </div>

</div>

  <!-- Success Confirmation Modal -->
<!-- Success Confirmation Modal -->
<div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
    <div class="modal-content text-center">
      <div class="modal-body">
        <p style="margin-bottom: 0;">{{ successMessage }}</p>
        <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
        <p class="lead mb-6">We will call you shortly</p>
        <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
      </div>
    </div>
  </div>
</div>

<section class="wrapper bg-light">
  <div class="container_wrapper pt-14 pt-md-16" style="margin-top: -112px; padding: 50px 100px;">
    <div class="row text-center" style="    margin-top: -60px;">
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <h2 class="fs-16 text-uppercase text-muted mb-3">SERVICE WE OFFER</h2>
        <h3 class="display-4 mb-10 px-xl-10">We offer a wide range of car services and repair to meet all your car needs!</h3>
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
    <div class="position-relative">
      <div class="shape rounded-circle bg-soft-blue rellax w-16 h-16" data-rellax-speed="1" style="bottom: -0.5rem; right: -2.2rem; z-index: 0;"></div>
      <div class="shape bg-dot yellow rellax w-16 h-17" data-rellax-speed="1" style="top: -0.5rem; left: -2.5rem; z-index: 0;"></div>
      <div class="row gx-md-5 gy-5 text-center">
        <!-- Existing boxes -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Periodic Service.png" class="custom-image1 mb-3" alt=""  />
              <h4>Periodic Service</h4>
              <p class="mb-2" style="font-size: 14px;">Service and Lubrication.</p>
              <!-- <a href="#" class="more hover link-yellow">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Engine Care.png" class="custom-image1 mb-3" alt="" />
              <h4>Engine Care</h4>
              <p class="mb-2">Tune-up and Overhaul.</p>
              <!-- <a href="#" class="more hover link-red">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Transmission.png" class="custom-image1 mb-3" alt="" />
              <h4>Transmission</h4>
              <p class="mb-2">Fluid, Gearbox, Clutch.</p>
              <!-- <a href="#" class="more hover link-green">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Suspension.png" class="custom-image1 mb-3" alt="" />
              <h4>Suspension </h4>
              <p class="mb-2">Shock, Strut, Alignment.</p>
              <!-- <a href="#" class="more hover link-blue">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->

        <!-- New boxes -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Brake Repair.png" class="custom-image1 mb-3" alt="" />
              <h4>Brake Repair</h4>
              <p class="mb-2">Pad, Rotor, Caliper.</p>
              <!-- <a href="#" class="more hover link-yellow">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Electrical Work.png" class="custom-image1 mb-3" alt="" />
              <h4>Electrical Work</h4>
              <p class="mb-2">Battery, Wiring, Alterna.</p>
              <!-- <a href="#" class="more hover link-red">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/HVAC Services.png" class="custom-image1 mb-3" alt="" />
              <h4>HVAC Services </h4>
              <p class="mb-2">AC, Heating System.</p>
              <!-- <a href="#" class="more hover link-green">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-xl-3">
          <div class="card shadow-lg">
            <div class="card-body">
              <img src="./assets/img/garage-details-images/Bodywork.png" class="custom-image1 mb-3" alt="" />
              <h4>Bodywork </h4>
              <p class="mb-2">Dent, Scratch, Full body.</p>
              <!-- <a href="#" class="more hover link-blue">Learn More</a> -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!--/column -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.position-relative -->
  </div>
  <!-- /.container -->
</section>

<!-- Why Choose Our Transparent Pricing Section -->
<section class="transparent-pricing">
<div class="powered-by">🚗 Powered by Autoverse</div>

<h1 class="gradient-title">Get Instant, Transparent</h1>
<div class="Price-Estimates">Price Estimates</div>
<div class="underline-price-estimate"></div>

<div class="Upfront-costs">Upfront costs with parts + labour split. No hidden fees, no surprises — 
just crystal-clear pricing you can trust. Get your estimate in under 60 seconds.</div>

<a (click)="goToRegistrationDecode()" class="main-btn">
  🚀 Get Price Estimates →
</a>

<div class="feature-pills">
<span>
  <div class="tick">✓</div>
  <div>Parts + Labour Split</div>
</span>
<span>
  <div class="tick">🔒</div>
  <div>Price Lock Guarantee</div>
</span>
<span>
  <div class="tick">💎</div>
  <div>Zero Hidden Charges</div>
</span>
</div>
<h2>Why Choose Our Transparent Pricing?</h2>
<p>Here’s why you can trust us with your vehicle needs.</p>
<div class="features">
<div class="feature-card">
  <div class="image-backgroun-color">
  <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE.png" alt="100% Genuine Parts">
  </div>
  <h3>100% Genuine Parts</h3>
  <div class="genuine-part-class">Every estimate is backed by Autoverse's reliable parts supply chain.</div>
</div>
<div class="feature-card">
  <div class="image-backgroun-color">
    <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE (1).png" alt="Transparent Pricing">
  </div>
  <h3>Transparent Pricing</h3>
  <div class="genuine-part-class">See parts and labour costs separately, so you always know what you're paying for.</div>
</div>
<div class="feature-card">
  <div class="image-backgroun-color">
    <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE (2).png" alt="Trusted Garages">
  </div>
  <h3>Trusted Garages</h3>
  <div class="genuine-part-class">Your garage is now powered by Autoverse — bringing trust and reliability to every estimate.</div>
</div>
</div>
                  <!-- Final Get Started Section -->
<section class="get-started">
<h2>Ready to Get Started?</h2>
<p>Get your transparent, detailed estimate in under 60 seconds. 
  No sign-up required, no hidden fees.</p>

<a (click)="goToRegistrationDecode()" class="cta-button">
  🚀 Start Your Estimate Now <span>&rarr;</span>
</a>

<div class="extra-info">
  ⚡ Average completion time: 45 seconds &nbsp; | &nbsp; 🔒 100% secure &nbsp; | &nbsp; 💎 No obligations
</div>
</section>
</section>

<!-- Makes -->
<section id="makes" class="wrapper bg-light">
  <div class="container " style="padding-top: 80px;">
    <div class="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0">
      <div class="col-lg-4 mt-lg-2">
        <h2 class="fs-15 text-uppercase text-muted mb-3">POPULAR CAR MAKES</h2>
        <h3 class="display-4 mb-3 pe-xxl-5">Trusted by top car brands</h3>
        <p class="lead fs-lg mb-0 pe-xxl-5">We serve a wide range of well-known car brands</p>
      </div>
      <div class="col-lg-8 position-relative d-flex align-items-center">
    <!-- Left Arrow -->
    <button
      class="btn-arrow-prev"
      (click)="scrollLeftMake()"
      [class.disabled]="isPrevDisabled"
    >
      &#8592;
    </button>

    <!-- Logos Grid Container -->
    <div class="makes-container overflow-hidden">
      <div class="makes-grid">
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/marutisuzuki.png" alt="Maruti Suzuki">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/hyundai.png" alt="Hyundai">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/toyota.png" alt="Toyota">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/honda.png" alt="Honda">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/volkswagen.png" alt="Volkswagen">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/tata.png" alt="Tata">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/ford.png" alt="Ford">
        </div>
        <div class="make-logo">
          <img src="https://cube.getpitstop.com/assets/img/mahindra.png" alt="Mahindra">
        </div>
      </div>
    </div>

    <!-- Right Arrow -->
    <button
      class="btn-arrow-next"
      (click)="scrollRightMake()"
      [class.disabled]="isNextDisabled"
    >
      &#8594;
    </button>
  </div>

    </div>
  </div>
</section>

<!-- ---------------------------INSURANCE BLOCK--------------------------- -->
<section class="wrapper bg-light wrapper-border"*ngIf="garageData?.insuranceUrls?.length > 0"id="insurance-section" style = "border:none" >
  <div class="container pt-md-10 pb-md-10">
    <p class="text-center mb-8">Trusted Cashless Partners for Top Insurers</p>

    <div class="ticker-wrapper">
      <div class="ticker">
        <div class="ticker-item" *ngFor="let url of garageData.insuranceUrls">
          <img [src]="url" alt="Insurance Partner" />
        </div>
        <!-- duplicate for infinite loop -->
        <div class="ticker-item" *ngFor="let url of garageData.insuranceUrls">
          <img [src]="url" alt="Insurance Partner" />
        </div>
      </div>
    </div>
  </div>
</section>

 <!-- ------------------------------TESTIMONIALS BLOCK-------------------- -->
<section class="wrapper bg-light" id="reviews-section">
  <div class="container pt-md-16">
    <h2 class="display-4 mb-3 text-center">Happy Customers</h2>
    <p class="lead text-center mb-6 px-md-16 px-lg-0">
      Customer satisfaction is our major goal. See what our customers are saying about us.
    </p>

    <div class="position-relative d-flex align-items-center">
      <!-- Prev Button -->
      <!-- <button class="btn-arrow-prev" (click)="scrollReviewsLeft()">
        &#8592;
      </button> -->
        <button class="btn-arrow-prev"
              (click)="scrollLeft()"
              [disabled]="isPrevDisabled">
        &#8592;
      </button>

      <!-- Scrollable Wrapper -->
      <div class="reviews-wrapper">
        <div class="review-card" *ngFor="let review of garageData?.reviews">
          <p class="testimonial">{{ review.testimonial }}</p>
          <h5 class="reviewer-name">{{ review.name }}</h5>
          <div class="stars">
            <ng-container *ngFor="let star of getStars(review.rating)">
              <i *ngIf="star === 'full'" class="bi bi-star-fill"></i>
              <i *ngIf="star === 'half'" class="bi bi-star-half"></i>
              <i *ngIf="star === 'empty'" class="bi bi-star"></i>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Next Button -->
      <!-- <button class="btn-arrow-next" (click)="scrollReviewsRight()">
        &#8594;
      </button> -->
       <button class="btn-arrow-next"
              (click)="scrollRight()"
              [disabled]="isNextDisabled">
        &#8594;
      </button>
    </div>
  </div>
</section>

<!-- /section -->

<!-- ----------------------------TEAM BLOCK--------------------- -->
<section class="wrapper bg-light" id="employee-section" style="display: none;">
  <div class="container ">
      <div class="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
          <div class="col-lg-4">
              <h2 class="fs-15 text-uppercase text-line text-primary text-center mb-3">Meet the Team</h2>
              <h3 class="display-5 mb-5">Save your time and money by choosing our expert team.</h3>
              <p>Get reliable repairs and top-notch service from skilled professionals you can trust. Experience quality and efficiency that keeps your car running smoothly.</p>
              <button id="see-all-btn" class="btn btn-primary rounded-pill mt-3">See All Members</button>
          </div>
          <div class="col-lg-8">
              <!-- Container for displaying three images -->
              <div id="showthreeimage" class="text-center mb-6">
                  <div class="row">
                      <!-- Dynamic employee slides for first 3 images will be inserted here -->
                  </div>
              </div>

              <!-- Container for displaying all images -->
              <div id="showallimage" class="text-center mb-6" style="display: none;">
                  <div class="row">
                      <!-- Dynamic employee slides for all images will be inserted here -->
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>


<!-- -----------------------------------------GALLERY BLOCK----------------- -->
<section class="wrapper bg-light" id="service-section"  *ngIf="garageData?.serviceImages?.length > 0" >
  <div class="container pt-14 pt-md-16">
    <div class="row">
      <div class="col-lg-9 col-xl-8 col-xxl-7 mx-auto text-center">
        <h2 class="fs-15 text-uppercase text-muted mb-3">OUR WORK</h2>
        <h3 class="display-4 mb-10">Take a look at the repairs and services we've done for various cars.</h3>
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
  <div class="container-fluid px-md-6">
    <div class="swiper-container blog grid-view mb-17 mb-md-19" data-margin="30" data-nav="true" data-dots="true" data-items-xxl="3" data-items-md="2" data-items-xs="1">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" id="service-images" style="display: flex;">
            <!-- <figure class="rounded"><img src="./assets/img/photos/pp10.jpg" alt="" /></figure> -->
          </div>
          
          <!--/.swiper-slide -->
        </div>
        <!--/.swiper-wrapper -->
      </div>
      <!-- /.swiper -->
    </div>
    <!-- /.swiper-container -->
  </div>
  <!-- /.container-fluid -->
</section>



<footer class="bg-light text-dark mt-0">
  <!-- Blue Box Section -->
  <div class="blue-box text-white py-4 mb-4">
    <div class="container">
      <div class="row align-items-center">
        <!-- Text Section -->
        <div class="col-md-8 text-md-start text-center mb-3 mb-md-0">
          <h2 class="getIn">
            Get in touch! <br>
            Leave your details for a callback and we'll contact you shortly
          </h2>
        </div>

        <!-- Button Section -->
        <div class="col-md-4 text-md-end text-center">
          <!-- Trigger Button for Modal -->
          <button class="btn btn-white" data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
            Request a Call Back
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Content Section -->
  <div class="container py-4">
    <div class="row text-center">
      <!-- Address Column -->
      <div class="col-md-4">
        <h5 class="mb-3">Address</h5>
        <p>
          {{ garageData?.address }}<br>
        </p>
      </div>

      <!-- Working Hours Column -->
      <div class="col-md-4">
        <h5 class="mb-3">Working Hours</h5>
        <p>
          Mon-Sat : {{ garageData?.workingHours }} <br>
          Sunday : Closed
        </p>
      </div>

      <!-- Email Column -->
      <div class="col-md-4">
        <h5 class="mb-3">E-mail</h5>
        <p>
          <a *ngIf="garageData?.email" href="mailto:{{ garageData.email }}">{{ garageData.email }}</a>
        </p>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="text-center mt-3">
      <p>© 2023 Autoverse. All rights reserved.</p>
    </div>
  </div>
</footer>
